'use es6';

import { AudienceTypes, Networks, AUDIENCE_MATCH_SIZE_TOO_SMALL_ERROR, AUDIENCE_SIZE_CUTOFF } from 'AdsUI/lib/Constants';
export const getAudienceAdAccount = (audience, adAccounts) => adAccounts.find(adAccount => adAccount.network === audience.targetingAudience.adNetwork && adAccount.accountId === audience.targetingAudience.adAccountId);
export const getWebsiteAudiencePixel = (audience, pixels) => audience.type === AudienceTypes.WEBSITE ? pixels.find(pixel => pixel.adNetwork === audience.targetingAudience.adNetwork && pixel.id === audience.targetingAudience.pixelId && pixel.accountId === audience.targetingAudience.adAccountId) : null;
export const getParentAudience = (audience, parentAudiences) => audience.type === AudienceTypes.LOOKALIKE ? parentAudiences.find(sourceAudience => sourceAudience.id === audience.targetingAudience.seedTargetingAudienceId) : null;
export const isAudienceMatchSizeTooSmall = audience => {
  const {
    networkState,
    targetingAudience
  } = audience; // Facebook and LinkedIn are the only networks that provide some info on whether an audience
  // is large enough to be used in campaign creation.
  //
  // Facebook audiences can always be used for campaign creation, even if matching isn't done yet.
  // but the resulting campaign's targeting might not reach the desired users if matching is still in progress.
  // Note that when matching is complete, Facebook eventually provides a "too small" status, which we can surface
  // to users to inform them that their targeting might not be ideal.
  //
  // LinkedIn audiences with less than 300 matched users cannot be used for campaign creation.

  switch (targetingAudience.adNetwork) {
    case Networks.FACEBOOK:
      {
        return networkState.errorMessage === AUDIENCE_MATCH_SIZE_TOO_SMALL_ERROR && networkState.errorCode === 300;
      }

    case Networks.LINKEDIN:
      {
        return networkState.approximateSize < AUDIENCE_SIZE_CUTOFF[Networks.LINKEDIN];
      }

    default:
      {
        return false;
      }
  }
};
export const isAudienceSizeUnavailable = audience => {
  const {
    networkState,
    targetingAudience
  } = audience; // The matched dize for Facebook contact list audiences comes back as -1 in many cases,
  // to prevent misuse of targeting.
  // Other networks have similar cases (e.g. Google returning "0"),
  // but it's hard to nail exact cases, so limit this check to Facebook, for now.

  switch (targetingAudience.adNetwork) {
    case Networks.FACEBOOK:
      {
        return networkState.approximateSize === -1;
      }

    default:
      {
        return false;
      }
  }
};
export const getAssociatedPixel = (audience, pixels) => {
  const {
    pixelId,
    adNetwork,
    adAccountId
  } = audience.targetingAudience; // It's possible, though not especially common, that the pixel used to create a website audience
  // is missing from available pixel list. Root cause is likely a shared pixel being revoked from
  // an ad account.

  return pixels.find(pixel => pixel.adNetwork === adNetwork && pixel.id === pixelId && pixel.accountId === adAccountId);
};